import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/frontend/layouts/default.vue")),
  "default-legacy": defineAsyncComponent(() => import("/opt/buildhome/repo/frontend/layouts/defaultLegacy.vue"))
}